import { styled, Typography } from '@ori-ui/mui';
import type { FC } from 'react';
import React from 'react';

interface PrivacyPolicyProps {
  text: string;
  linkText: string;
  url: string;
}

const Root = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(0, 3, 4, 3),
  color: theme.palette.grey.A400,
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(0, 6, 6, 6),
  },
})) as typeof Typography;

const Link = styled('a')(({ theme }) => ({
  color: theme.palette.grey.A400,
  textDecoration: 'underline',
}));

export const PrivacyPolicy: FC<PrivacyPolicyProps> = ({ text, linkText, url }) => {
  const LINK_PLACE = '{0}';
  const splitText: string[] = text.split(LINK_PLACE);

  return (
    <Root
      component="div"
      variant="caption"
    >
      {splitText[0]}
      <Link
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {linkText}
      </Link>
      {splitText[1]}
    </Root>
  );
};
